import { Body, Injectable } from '@nestjs/common';
import { Repository, Raw, getConnection } from 'typeorm';
import { InjectRepository } from '@nestjs/typeorm';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import {Certificates} from './certificates.entity';
import {CertificatesDTO} from './dto/certificates.dto';
import {CertificatesAdapter} from './dto/certificates.adapter';
import { AllCertificatesResponseModel, CertificatesResponseModel } from '@gtpl/shared-models/masters';
import { CertificatesRequest } from './dto/certificates.request';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { UserRequestDto } from './dto/user-request-dto';
// import {LogsService} from '.shared-services/user-logs/src/lib/user-logs-service';
@Injectable()
export class CertificatesService {
    constructor(
        private logService:LogsService,
        @InjectRepository(Certificates)
        private certificatesRepository: Repository<Certificates>,
        private certificatesAdapter: CertificatesAdapter,
    ){}

    async getCertificatesWithoutRelations(certificateName: string): Promise<Certificates> {
        // tslint:disable-next-line: typedef
        const certificatesResponse = await this.certificatesRepository.findOne({
          where: {certificateName: Raw(alias => `certificate_name = '${certificateName}'`)},
        });
        if (certificatesResponse) {
          return certificatesResponse;
        } else {
          return null;
        }
      }

      async createCertificate(certificatesDto: CertificatesDTO, isUpdate: boolean): Promise<CertificatesResponseModel> {
        console.log(certificatesDto);
        try {
          let previousValue
          // to check whether State exists with the passed  State code or not. if isUpdate is false, a check will be done whether a record with the passed Statecode is existing or not. if a record exists then a return message wil be send with out saving the data.  if record is not existing with the passed State code then a new record will be created. if isUpdate is true, then no check will be performed and  record will be updated(if record exists with the passed cluster code) or created.
          console.log(isUpdate);
          // const newLogDto = new LogsDto(1,'create', 'Certificates', certificatesDto.certificateId, true, '',certificatesDto.createdUser)
          //   let res = await this.logService.createLog(newLogDto);
          //   console.log(res);
          if (!isUpdate) {
            const CertificatesEntity = await this.getCertificatesWithoutRelations(certificatesDto.certificateName);
            if (CertificatesEntity) {
              //return new InformationMessageError(11104, "State already exists");
              throw new CertificatesResponseModel(false,11104, 'Certificate Name already exists');
            }
          }
          else{
            const certificatePrevious = await this.certificatesRepository.findOne({where:{certificateId:certificatesDto.certificateId}})
            previousValue = certificatePrevious.certificateName
            console.log(previousValue)
            const CertificatesEntity = await this.getCertificatesWithoutRelations(certificatesDto.certificateName);
            if (CertificatesEntity) {
              if(CertificatesEntity.certificateId!=certificatesDto.certificateId) {
                throw new CertificatesResponseModel(false,11104, 'Certificate already exists');      
              }
            }
          }
          const convertedCertificatesEntity: Certificates = this.certificatesAdapter.convertDtoToEntity(certificatesDto,isUpdate);
          const savedCertificatesEntity: Certificates = await this.certificatesRepository.save(
            convertedCertificatesEntity
          );
          const savedCertificatesDto: CertificatesDTO = this.certificatesAdapter.convertEntityToDto(savedCertificatesEntity);
            // console.log(savedStateDto);
          if (savedCertificatesDto) {
            const certificatePresent = savedCertificatesDto.certificateName;
            console.log(certificatePresent)
            // generating response
            const response = new CertificatesResponseModel(true,1,isUpdate? 'Certificates Updated Successfully': 'Certificate Created Successfully')
             const name =isUpdate ? 'update':'create'
             const userName = isUpdate ? savedCertificatesDto.updatedUser : savedCertificatesDto.createdUser
             const displayValue = isUpdate? 'Certificates Updated Successfully': 'Certificate Created Successfully'
            const newLogDto = new LogsDto(1,name, 'Certificates', savedCertificatesDto.certificateId, true, displayValue,userName,previousValue,certificatePresent)
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            // await this.logService.createLog(1,'create', 'Certificates', savedCertificatesDto.certificateId, true, '');

            return response
          } else {
            //return new InformationMessageError(11106, "State saved but issue while transforming into DTO");
            throw new CertificatesResponseModel(false,11106,'Certificates saved but issue while transforming into DTO');
          }
        } catch (error) {
          // when error occures while saving the data , the execution will come to catch block.
          // tslint:disable-next-line: typedef
          return error;
        }

      }  
      async getAllCertificates(req?:UserRequestDto): Promise<AllCertificatesResponseModel> {
        console.log(req,'userrequest')
        try {
          const CertificatesDto: CertificatesDTO[] = [];
          const CertificatesEntities: Certificates[] = await this.certificatesRepository.find({order :{'certificateName':'ASC'}});
          //retrieves all companies
          //console.log(statesEntities);
          if (CertificatesEntities) {
             // converts the data fetched from the database which of type companies array to type StateDto array.
             CertificatesEntities.forEach(CertificatesEntity => {
              const convertedCertificatesDto: CertificatesDTO = this.certificatesAdapter.convertEntityToDto(
                CertificatesEntity
              );
              CertificatesDto.push(convertedCertificatesDto);
            });
          
            const response = new AllCertificatesResponseModel(true,1,'Certificates retrieved successfully',CertificatesDto);
            // await this.logService.createLog(1,'view', 'Certificates', null, true, '');
            if(req?.createdUser){
              const newLogDto = new LogsDto(0,'view', 'Certificates', 0, true, 'Certificates retrieved successfully',req.createdUser,'','')
            let res = await this.logService.createLog(newLogDto);
            console.log(res);
            }
            
            return response
          } else {
            throw new CertificatesResponseModel(false,99998, 'Data not found');
          }
        
        } catch (err) {
          return err;
        }
      }
      async getAllActiveCertificates(): Promise<AllCertificatesResponseModel> {
        // const page: number = 1;
        try {
            const certificatesDto: CertificatesDTO[] = [];
            //retrieves all companies
            const CertificatesEntities: Certificates[] = await this.certificatesRepository.find({ order: { 'certificateName': 'ASC' },where:{isActive:true}
           });
         console.log(CertificatesEntities)
            if (CertificatesEntities) {
                // converts the data fetched from the database which of type companies array to type StateDto array.
                CertificatesEntities.forEach(certificatesEntity => {
                    const convertedcertificatesDto: CertificatesDTO = this.certificatesAdapter.convertEntityToDto(
                      certificatesEntity
                    );
                    certificatesDto.push(convertedcertificatesDto);
                });
                const response = new AllCertificatesResponseModel(true, 11108, "Certificates retrieved successfully", certificatesDto);
            //     const newLogDto = new LogsDto()
            // await this.logService.createLog(newLogDto);
               
                return response;
            } else {
                throw new CertificatesResponseModel(false,99998, 'Data not found'); certificatesDto
            }
        } catch (err) {
          return err;
        }
    }
      async activateOrDeactivateCertificates(certificatesRequest: CertificatesRequest): Promise<CertificatesResponseModel> {
        try {
            const certificatesExists = await this.getCertificatesById(certificatesRequest.certificateId);
            if (certificatesExists) {
                if (certificatesRequest.versionFlag !==certificatesExists.versionFlag) {
                    throw new CertificatesResponseModel(false,10113, 'Someone updated the current Certificates information.Refresh and try again');
                } else {
                    
                        const certificatesStatus =  await this.certificatesRepository.update(
                            { certificateId: certificatesRequest.certificateId },
                            { isActive: certificatesRequest.isActive,updatedUser: certificatesRequest.updatedUser });
                       
                        if (certificatesExists.isActive) {
                            if (certificatesStatus.affected) {
                                const certificatesResponse: CertificatesResponseModel = new CertificatesResponseModel(true, 10115, 'Certificate is de-activated successfully');
                                return certificatesResponse;
                            } else {
                                throw new CertificatesResponseModel(false,10111, 'Certificate is already deactivated');
                                // await this.logService.createLog(1,'create', 'Certificates', savedCertificatesDto.certificateId, true, '');

                            }
                        } else {
                            if (certificatesStatus.affected) {
                                const certificatesResponse: CertificatesResponseModel = new CertificatesResponseModel(true, 10114, 'Certificate is activated successfully');
                                return certificatesResponse;
                            } else {
                                throw new CertificatesResponseModel(false,10112, 'Certificate is already  activated');
                              //  await this.logService.createLog(1,'create', 'Certificates', savedCertificatesDto.certificateId, true, '');

                            }
                        }
                    // }
                }
            } else {
                throw new CertificatesResponseModel(false,99998, 'No Records Found');
            }
        } catch (err) {
          return err;
        }
    }

    async getCertificatesById(certificateId: number): Promise<Certificates> {
        //  console.log(employeeId);
            const Response = await this.certificatesRepository.findOne({
            where: {certificateId: certificateId},
            });
            // console.log(employeeResponse);
            if (Response) {
            return Response;
            } else {
            return null;
            }
        }
        async getCertificationById(@Body() certificatesRequest:CertificatesRequest): Promise<CertificatesResponseModel> {
          // const page: number = 1;
          try {
            // console.log('jjjjjjjjjjjjjj');
            //retrieves all companies
            const certificatesEntities: Certificates = await this.certificatesRepository.findOne({
              where:{certificateId:certificatesRequest.certificateId}
              });
              
              const certificatesData: CertificatesDTO = this.certificatesAdapter.convertEntityToDto(certificatesEntities);
              if (certificatesData) {
                  const response = new CertificatesResponseModel(true, 11101 , 'Certificates retrived Successfully',certificatesData);
                  return response;
              }
              else{
                  throw new CertificatesResponseModel(false,11106,'Something went wrong');
              }
              // generating resposnse
              
          } catch (err) {
            return err;
          }
        }
}

